import type { ImplementedCategoryId, Venue } from '@anjabom/core';

export const venueQueryTooLong = (query: string) => query.trim().length > 100;
export type VenueSearchResult = { status: 'ready'; venues: Venue[] } | { status: 'invalid' | 'unavailable'; venues: null };

export async function loadVenueSearch(category: ImplementedCategoryId, query: string, signal: AbortSignal): Promise<VenueSearchResult> {
  if (venueQueryTooLong(query)) return { status: 'invalid', venues: null };
  try {
    const response = await fetch(`/api/venues?category=${encodeURIComponent(category)}&q=${encodeURIComponent(query)}`, { signal });
    if (response.status === 400) return { status: 'invalid', venues: null };
    if (!response.ok) return { status: 'unavailable', venues: null };
    const value = await response.json() as { venues?: unknown };
    return Array.isArray(value.venues) ? { status: 'ready', venues: value.venues as Venue[] } : { status: 'unavailable', venues: null };
  } catch (error) {
    if (signal.aborted) throw error;
    return { status: 'unavailable', venues: null };
  }
}
